import React, { useState, useEffect } from 'react'
import ArrowUpIcon from 'src/assets/icons/arrow_up.svg'

const ButtonToTop = () => {
  const [isVisible, setIsVisible] = useState(false)

  const toggleVisibility = () => {
    if (window.scrollY > 500) {
      setIsVisible(true)
    } else {
      setIsVisible(false)
    }
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility)
    return () => window.removeEventListener('scroll', toggleVisibility)
  }, [])

  return (
    <>
      <button
        onClick={scrollToTop}
        className={`fixed z-50 bottom-0 mb-8 right-0 mr-6 w-12 h-12 rounded-full text-center flex flex-col items-center justify-center shadow-lg transition-opacity duration-100 bg-white hover:bg-secondary text-secondary hover:text-white border border-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-secondary ${
          isVisible ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}
        aria-label="Back to top"
      >
        <ArrowUpIcon className="h-6 w-6 -mb-1 fill-current" />
        <span>TOP</span>
      </button>
    </>
  )
}

export default ButtonToTop
